import { GET_JMS_DETAILS, SUBMIT_JMS_DATA, GET_JMS_LIST } from './type';

const INITIAL_STATE = {
  jmsDetailsState: null,
  jmsSubmitState: null,
  jmsListState: null
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case GET_JMS_DETAILS:
      return { ...state, jmsDetailsState: action.payload };
    case SUBMIT_JMS_DATA:
      return { ...state, jmsSubmitState: action.payload };
    case GET_JMS_LIST:
      return { ...state, jmsListState: action.payload };
    default:
      return state;
  }
};
